<div class="h-full bg-pmdf-primary! border-l! border-white/10! text-white! flex flex-col">
  <!-- Cabeçalho -->
  <div class="flex items-center justify-between p-pmdf-4 border-b border-white/10">
    <h3 class="text-pmdf-subheading">Notificações</h3>
    <button mat-icon-button
            (click)="layout.toggleQuickpanel()"
            class="text-white/60 hover:text-white transition-colors"
            aria-label="Fechar painel">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Lista de notificações -->
  <div class="flex-1 overflow-y-auto p-pmdf-4 bg-pmdf-primary!">
    <div class="flex flex-col gap-pmdf-3">
      <!-- Urgente -->
      <div class="p-pmdf-3 bg-white/5 rounded-pmdf-card border-l-2 border-pmdf-danger hover:bg-white/10 transition-colors cursor-pointer">
        <div class="flex items-start gap-2">
          <mat-icon class="text-pmdf-danger icon-sm mt-0.5 shrink-0">assignment_late</mat-icon>
          <div>
            <p class="text-xs font-bold">Avaliação Pendente</p>
            <p class="text-[10px] opacity-70 mt-0.5">3 avaliações da equipe aguardam homologação.</p>
            <p class="text-[9px] opacity-40 mt-1">Há 2 horas</p>
          </div>
        </div>
      </div>

      <!-- Aviso -->
      <div class="p-pmdf-3 bg-white/5 rounded-pmdf-card border-l-2 border-pmdf-warning hover:bg-white/10 transition-colors cursor-pointer">
        <div class="flex items-start gap-2">
          <mat-icon class="text-pmdf-warning icon-sm mt-0.5 shrink-0">hotel</mat-icon>
          <div>
            <p class="text-xs font-bold">Aprovação de Férias</p>
            <p class="text-[10px] opacity-70 mt-0.5">Férias do 3º Sgt PM João requerem análise.</p>
            <p class="text-[9px] opacity-40 mt-1">Há 4 horas</p>
          </div>
        </div>
      </div>

      <!-- Informativo -->
      <div class="p-pmdf-3 bg-white/5 rounded-pmdf-card border-l-2 border-pmdf-info hover:bg-white/10 transition-colors cursor-pointer">
        <div class="flex items-start gap-2">
          <mat-icon class="text-pmdf-info icon-sm mt-0.5 shrink-0">article</mat-icon>
          <div>
            <p class="text-xs font-bold">Novo Boletim Geral</p>
            <p class="text-[10px] opacity-70 mt-0.5">O BCG nº 105/2026 já está disponível.</p>
            <p class="text-[9px] opacity-40 mt-1">Há 1 dia</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Rodapé -->
  <div class="p-pmdf-3 border-t border-white/10 text-center">
    <button class="text-xs text-white/50 hover:text-white transition-colors">
      Ver todas as notificações
    </button>
  </div>
</div>
